// Vendor imports
const qs = require('qs')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const commonClient = require('client-v2/common/client')
// Entry imports
const configureStore = require('./state/store')
const rootFactory = require('./components/root').factory
const feedActions = require('./containers/feed/actions')

const businessEventsPageActions = {
  'interest-profile.showFollowers': 'followers',
  'interest-profile.showPosts': 'posts'
}

commonClient.runAfterPageIsLoaded(() => {

  const { store } = commonClient.render(configureStore, rootFactory)

  const initialState = store.getState()
  const { feed, interest, router, user } = initialState

  const pageAction = businessEventsPageActions[router.action]

  commonClient.configureSession(store, {
    pageName: `interest.${pageAction}`,
    streamKey: feed.meta.streamKey,
    streamType: feed.meta.streamType
  })

  businessEvents.trackProtobuf('TrackTopicProfileView', {
    userId: user.id,
    topicKey: interest.key
  })
  businessEvents.trackSegment('pageview')

  const queryParams = qs.parse(router.location.search, { ignoreQueryPrefix: true })
  if (pageAction === 'posts' && queryParams.modal) {
    store.dispatch(feedActions.showArticleProfileModal())
  }

})
